import React, { Component, Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { Icon } from "@iconify/react";

import MKIDatatable from "../../../../modules/mki-datatable/lib";
import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/base";
import { Row, Col, Tooltip } from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { config } from "../../../../helpers/config_global";
import { accessRole } from "../../../../helpers/access_role";
import moment from "moment";
import CloseTicketModal from "../../Componenets/CloseTicketModal";
import DataTableBloc from "../Blocs/DataTableBloc";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  userdata = JSON.parse(localStorage.getItem("userdata"));

  source;
  historyTable = "historyTicketTableActive";
  defaultOrder = "created_at";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      notulenUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      showCloseTicketModal: false,
      toggleModal: false
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: [4],
      employee_uuid: this.userdata.employee_uuid,
      start_date: this.props.filter?.helpdeskStartDate,
      end_date: this.props.filter?.helpdeskEndDate,
    };
    await this.dataTableBloc.fetchCloseTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  exportExcel = () =>{
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: [4],
      employee_uuid: this.userdata.employee_uuid,
      start_date: this.props.filter?.helpdeskStartDate,
      end_date: this.props.filter?.helpdeskEndDate,
    };
    this.dataTableBloc.fetchHelpdeskExport(query);
  }

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.closetableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          this.props.cb(response.total, "close");
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.helpdeskExportChannel.subscribe((result) => {
      switch (result.status) {
          case apiResponse.LOADING:
              this.setState({
                  loadingExport: true,
              })
              break
          case apiResponse.COMPLETED:
              const link = result.data.response
              window.open(link.file_url, "_blank")
              this.setState({
                  loadingExport: false,
                  successExport: true
              })
              setTimeout(() => {
                  this.setState({
                      successExport: false,
                  })
              }, 1000);
              break
          case apiResponse.ERROR:
              this.setState({
                  urlFileDetail: link,
                  loadingExport: false,
                  failedExport: true
              })
              setTimeout(function() {
                  this.setState({
                      failedExport: false,
                  })
              }, 1000)
              break
          default:
              break
      }
    })
  }

  toggleModal = () => {
    this.setState({
      showCloseTicketModal: !this.state.showCloseTicketModal,
      toggleModal: !this.state.toggleModal
    })
  };

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
    this.dataTableBloc.helpdeskExportChannel.unsubscribe();
  }

  columns = [
    // {
    //   key: "ticket_tracking_id",
    //   text: "Tracking ID",
    //   className: "address",
    //   sortable: true,
    //   cell: (ticket) => {
    //     return (
    //       <Link to={`/admin/helpdesk.html?detail&uuid=${ticket.ticket_uuid}`}>
    //         <span style={{ fontWeight: 500 }}>
    //           {ticket.ticket_tracking_id.toUpperCase()}
    //         </span>
    //       </Link>
    //     );
    //   },
    // },
    {
      key: "ticket_tracking_id",
      text: "Tracking ID",
      className: "address",
      sortable: true,
      cell: (ticket) => {
        return (
          <Link to={`/admin/helpdesk.html?detail&uuid=${ticket.ticket_uuid}`}>
            <span style={{ fontWeight: 500 }}>
              {ticket.ticket_tracking_id.toUpperCase()}
            </span>
          </Link>
        );
      },
    },
    {
      key: "ticket_init_name",
      text: "Nama",
      className: "address",
      sortable: true,
    },
    //desc
    {
      key: "ticket_subject",
      text: "Subjek",
      className: "subjek",
      sortable: true,
    },
    {
      key: "service_name",
      text: "Layanan",
      className: "service",
      sortable: true,
    },
    {
      key: "module_name",
      text: "Modul",
      className: "module",
      sortable: true,
    },
    //status
    {
      key: "ticket_status",
      text: "Status",
      className: "status",
      sortable: true,
      cell: (ticket) => {
        let className = "";
        let text = "";

        switch (ticket.ticket_status) {
          case 0:
            className = "text-danger";
            text = "New";
            break;

          case 1:
            className = "text-success";
            text = "Open";
            break;

          case 2:
            className = "text-warning";
            text = "Menunggu balasan";
            break;

          case 3:
            className = "text-primary";
            text = "Dibalas";
            break;

          case 4:
            className = "text-purple";
            text = "Closed";
            break;

          default:
            text = "-";
            break;
        }

        return (
          <span
            className={className}
            style={{ fontSize: ".75rem", fontWeight: 500 }}
          >
            {text}
          </span>
        );
      },
    },
    //location
    {
      key: "ticket_layer_name",
      text: "Layer",
      className: "ticket_layer_name",
      sortable: true,
      width: "10%",
    },
    //priority
    {
      key: "ticket_priority",
      text: "Prioritas",
      className: "priority",
      sortable: true,
      width: "10%",
      cell: (ticket) => {
        let className = "";
        let text = "";

        switch (ticket.ticket_priority) {
          case 0:
            className = "text-secondary";
            break;

          case 1:
            className = "text-secondary";
            break;

          case 2:
            className = "text-success";
            break;

          case 3:
            className = "text-warning";
            break;

          case 4:
            className = "text-danger";
            break;

          default:
            break;
        }

        return (
          <Row>
            <Col md={2}>
              <Icon icon="gg:overflow" className={className} />
            </Col>
            <Col md={10}>
              <span
                className={className}
                style={{ fontSize: ".75rem", fontWeight: 500 }}
              >
                {ticket.ticket_priority_name}
              </span>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "ticket_classification",
      text: "Klasifikasi",
      className: "classification",
      sortable: true,
      width: "10%",
      cell: (ticket) => {
        let className = "";

        switch (ticket.ticket_classification) {
          case 0:
            className = "text-secondary";
            break;

          case 1:
            className = "text-secondary";
            break;

          case 2:
            className = "text-success";
            break;

          case 3:
            className = "text-danger";
            break;
          default:
            break;
        }

        return (
          <Row>
            <Col md={2}>
              <Icon icon="gg:overflow" className={className} />
            </Col>
            <Col md={10}>
              <span
                className={className}
                style={{ fontSize: ".75rem", fontWeight: 500 }}
              >
                {ticket.ticket_classification_name}
              </span>
            </Col>
          </Row>
        );
      },
    },
    {
      key: "ticket_last_replier_name",
      text: "Terakhir dibalas",
      className: "last_reply",
      sortable: true,
      width: "10%",
    },
    {
      key: "created_at",
      text: "Tanggal Dibuat",
      className: "created_at",
      sortable: true,
      cell: ({ created_at }) => {
        return <>{moment(created_at).format("lll")}</>;
      },
    },
    {
      key: "updated_at",
      text: "Update Terakhir",
      className: "address",
      sortable: true,
      cell: ({ updated_at }) => {
        return <>{moment(updated_at).format("lll")}</>;
      },
    },
    //action
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 150,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.ticket_id;
        return (
          <Fragment>
            {accessRole("update") ? (
              <span>
                <button
                  className="btn btn-primary btn-sm"
                  id={"detail-" + thisId}
                  onClick={() => {
                    this.setState({
                      detailUuid: record.ticket_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    marginBottom: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-align-left"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["detail" + thisId]}
                  target={"detail-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["detail" + thisId]: !this.state["detail" + thisId],
                    });
                  }}
                >
                  Detail
                </Tooltip>
              </span>
            ) : null}
            {accessRole("delete") && accessRole("update") && record.ticket_solved_time === null && record.ticket_layer == 1 && record.ticket_pic_uuid == this.userdata.employee_uuid ? (
              <span>
                <button
                  className="btn btn-purple btn-sm"
                  id={"close-" + thisId}
                  onClick={() => {
                    this.setState({
                      showCloseTicketModal: true,
                      toggleModal: true,
                      ticketUuid: record.ticket_uuid,
                    });
                  }}
                  style={{
                    padding: "2px 5px",
                    marginRight: "2px",
                    marginBottom: "2px",
                  }}
                >
                  <i className="uil-sign-out-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["close" + thisId]}
                  target={"close-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["close" + thisId]: !this.state["close" + thisId],
                    });
                  }}
                >
                  Tutup Tiket
                </Tooltip>
              </span>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
					minWidth={1000}
          dynamic={true}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menutup ticket ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Ticket berhasil ditutup!"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan mengunduh data ini?"
          loadingTitle="Mengambil data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil unduh."
          failedTitle="Gagal!"
          failedInfo="Data gagal diunduh."
          showConfirm={this.state.confirmExport}
          showLoading={this.state.loadingExport}
          showSuccess={this.state.successExport}
          showFailed={this.state.failedExport}
          response={this.confirmResponseEscalation}
        />

        <CloseTicketModal
            showModal={this.state.showCloseTicketModal}
            toggleModal={this.toggleModal}
            ticketUuid={this.state.ticketUuid}
        />

        {this.state.detailUuid !== null ? (
          <Redirect to={"helpdesk.html?detail&uuid=" + this.state.detailUuid} />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect to={"helpdesk.html?update&uuid=" + this.state.updateUuid} />
        ) : null}
        {this.state.notulenUuid !== null ? (
          <Redirect
            to={"helpdesk.html?notulen&uuid=" + this.state.notulenUuid}
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
